module.exports = __webpack_public_path__ + "static/media/mail.d8ff208a.svg";